import { Sparkles } from 'lucide-react'

interface Props {
  message: string
  actionLabel?: string
  onAction?: () => void
}

export default function ProcessingBanner({ message, actionLabel, onAction }: Props) {
  return (
    <div className="mb-4 flex items-center justify-between gap-4 rounded-xl border border-ub-blue-200 bg-ub-blue-50 px-4 py-3">
      <div className="flex items-center gap-3">
        <div className="rounded-lg bg-white p-2 text-ub-blue-600">
          <Sparkles className="h-4 w-4" />
        </div>
        <span className="text-sm font-medium text-ub-blue-900">{message}</span>
      </div>
      {actionLabel && onAction && (
        <button
          onClick={onAction}
          className="rounded-lg bg-ub-blue-600 px-3 py-1.5 text-sm font-medium text-white hover:bg-ub-blue-700 transition"
        >
          {actionLabel}
        </button>
      )}
    </div>
  )
}
